import { Navigate, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { useAuth } from "./context/AuthContext";
import { AppShell } from "./components/AppShell";

const LoginPage = lazy(() => import("./pages/LoginPage").then((module) => ({ default: module.LoginPage })));
const WorkspacePage = lazy(() => import("./pages/WorkspacePage").then((module) => ({ default: module.WorkspacePage })));
const BoardPage = lazy(() => import("./pages/WorkspacePage").then((module) => ({ default: module.BoardPage })));
const BoardsIndexPage = lazy(() => import("./pages/BoardsIndexPage").then((module) => ({ default: module.BoardsIndexPage })));
const PlannerPage = lazy(() => import("./pages/PlannerPage").then((module) => ({ default: module.PlannerPage })));
const VideosPage = lazy(() => import("./pages/VideosPage").then((module) => ({ default: module.VideosPage })));
const WorkflowsPage = lazy(() => import("./pages/WorkflowsPage").then((module) => ({ default: module.WorkflowsPage })));
const WorkflowEditorPage = lazy(() => import("./pages/WorkflowsPage").then((module) => ({ default: module.WorkflowEditorPage })));
const LegalPage = lazy(() => import("./pages/LegalPage").then((module) => ({ default: module.LegalPage })));
const AccountPage = lazy(() => import("./pages/AccountPage").then((module) => ({ default: module.AccountPage })));

export function App() {
  const { profile, loading } = useAuth();
  if (loading) return <div className="app-loading" role="status">Pactios OS</div>;

  return <Suspense fallback={<div className="app-loading" role="status">Pactios OS</div>}>
    <Routes>
      <Route path="/login" element={profile ? <Navigate to="/workspace" replace /> : <LoginPage />} />
      <Route element={profile ? <AppShell /> : <Navigate to="/login" replace />}>
        <Route index element={<Navigate to="/workspace" replace />} />
        <Route path="/workspace" element={<WorkspacePage />} />
        <Route path="/boards" element={<BoardsIndexPage />} />
        <Route path="/boards/:boardId" element={<BoardPage />} />
        <Route path="/planner" element={<PlannerPage />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/workflows" element={<WorkflowsPage />} />
        <Route path="/workflows/:workflowId" element={<WorkflowEditorPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/account" element={<AccountPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Suspense>;
}
